// Constants 
import { TEMPLATE } from "../../constants";

// Services Library
import { TIME } from "../../services/util";

const { EMPLOYEE_FAIL_REASON } = TEMPLATE.EMPLOYEE

const checkDuplicate = (srcData, property, key) => {
    return srcData.some((item) => item.key !== key && item[property] === srcData.find(data => data.key === key)[property]);
  };

export const failReasonUser = (record, srcData, employees, company) => {
    let failMsg = [];

    const hasEmptyField = Object.values(record).some((d) => d === "" || d === undefined || d === null)
    const phoneDuplicate = checkDuplicate(srcData, 'contact_hp', record.key);
    const icDuplicate = checkDuplicate(srcData, 'ic', record.key);

    const icPattern = /^\d{6}-\d{2}-\d{4}$/;

    if (record.reasonMessages) {
      failMsg.push(record.reasonMessages);
    } else {
      if (hasEmptyField) {
        failMsg.push(EMPLOYEE_FAIL_REASON.MISSING);
      } 
      if (employees.some((v) => v.contact === record.contact)) {
        failMsg.push(EMPLOYEE_FAIL_REASON.EXIST_PHONE);
      }
      if (phoneDuplicate) {
        failMsg.push(EMPLOYEE_FAIL_REASON.DUPLICATED_PHONE);
      }
      if (employees.some((v) => v.ic === record.ic)) {
        failMsg.push(EMPLOYEE_FAIL_REASON.EXIST_IC);
      }
      if (icDuplicate) {
        failMsg.push(EMPLOYEE_FAIL_REASON.DUPLICATED_IC);
      }
      if (record.ic){
        if(!icPattern.test(record.ic)) {
          failMsg.push(EMPLOYEE_FAIL_REASON.WRONGFORMAT1);
        }
        if(!icPattern.test(record.bank_holderIc)) {
          failMsg.push(EMPLOYEE_FAIL_REASON.WRONGFORMAT2);
        }
      } 
      if (record.coid) {
        if (!company[record.coid]) {
          failMsg.push(EMPLOYEE_FAIL_REASON.EXIST);
        }
      }
      if (record?.contact_hp?.length < 10 || record?.contact_hp?.length > 13) {
        failMsg.push(EMPLOYEE_FAIL_REASON.TOO_SHORT);
      }
    };
    return failMsg;
}

  export const dataFailUser = (srcData, employees, company) => {
    return srcData.filter((data, index, array) => {

    if (data.isNew) {
      return false;
    }

    const hasEmptyField = Object.values(data).some((d) => d === "" || d === undefined || d === null)
    const phoneDuplicate = checkDuplicate(array, 'contact_hp', data.key);
    const icDuplicate = checkDuplicate(array, 'ic', data.key);
    const icPattern = /^\d{6}-\d{2}-\d{4}$/;

    if (data.reasonMessages) {
        return true; 
    }
    if (employees.some((v) => v.contact === data.contact)) {
      return true
    }
    if (data?.contact_hp?.length < 10 || data?.contact_hp?.length > 13) {
      return true; 
    }
    if (phoneDuplicate) {
      return true; 
    }
    if (employees.some((v) => v.ic === data.ic)) {
      return true
    }
    if (icDuplicate) {
      return true; 
    }
    if (hasEmptyField) {
      return true; 
    }
    if (data.ic){
        if(!icPattern.test(data.ic)) {
          return true
        }
        if(!icPattern.test(data.bank_holderIc)) {
          return true
        }
      }
      
    if (!company[data.coid]) {
    return true; 
    }

  return false; 
});
}
